import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilterSelectItem } from '../../../models/filter-select-item';
import { MatSelect, MatSelectTrigger } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-filter-select',
    templateUrl: './filter-select.component.html',
    styleUrls: ['./filter-select.component.scss'],
    imports: [MatFormField, MatLabel, MatSelect, FormsModule, ReactiveFormsModule, MatTooltip, MatSelectTrigger, MatOption, MatError]
})
export class FilterSelectComponent implements OnInit {
  
  @Input() form: FormGroup;
  @Input() color = 'primary';
  @Input() appearance = 'outline';
  @Input() floatLabel = 'always';
  @Input() multiple = true;
  @Input() controlName = 'filter-select';
  @Input() label = "Filter Select";
  @Input() placeholder = "";
  @Input() toolTipPosition = 'above';
  @Input() selectAllEnabled = true;
  @Input() noneEnabled = false;
  @Input() required = false;

  @Input() options: FilterSelectItem[] = [];
  allOption: FilterSelectItem = {ID: 0, Description: 'All', LinkAssociations: [], Selected: false};
  noneOption: FilterSelectItem = {ID: -1, Description: 'None', LinkAssociations: [], Selected: false};
  control = new FormControl(null);

  @Output() ready = new EventEmitter();
  @Output() valueChanged = new EventEmitter();

  @ViewChild(MatSelect) select: MatSelect;

  constructor() { 
    //TODO
  }

  ngOnInit(): void {

    if(this.required) {
      this.control.setValidators([Validators.required]);
    }

    if(this.form) {
      this.form.addControl(this.controlName, this.control);
    }

    this.ready.emit();

    //this.getOptionData();
  }

  setOptions(options: FilterSelectItem[]) {
    this.options = options;
  }

  setValues(values: FilterSelectItem[]) {
    if(!values) {
      return;
    }

    if(values.length == 0) {
      this.control.setValue([this.allOption]);
      this.onToggleItem(this.select.options.get(0));
      return;
    }

    this.allOption.Selected = false;
    this.control.setValue(values);
  }

  setSingleModeValue(value: FilterSelectItem) {
    if(!value) {
      return;
    }

    const item = this.options.find(i => i.ID == value.ID);
    this.control.setValue(item);
  }

  getValues() {
    if(this.allOption.Selected) {
      return [this.allOption];
    }

    return this.control?.value;
  }

  getSingleModeValue() {
    return this.control?.value;
  }

  onToggleItem(item: MatOption) {
    if(item.value == this.allOption) {
      if(item.selected) {
        this.allOption.Selected = true;
        this.select.options.forEach(o => o.select());
        return;
      }

      this.allOption.Selected = false;
      this.select.options.forEach(o => o.deselect());

    } else {
      
      const allItem = this.select.options.get(0);

      if(!item.selected && allItem.selected) {
        this.allOption.Selected = false;
        allItem.deselect();
        return;
      }

      if(item.selected && !allItem.selected) {
        const check = this.checkOptionAllStatus();
        if(check) {
          this.allOption.Selected = true;
          allItem.select();
        }
      }
    }
  }

  onSelectionChange() {
    this.valueChanged.emit(this.control?.value);
  }

  checkOptionAllStatus() {
    let result = true;
    this.select.options.forEach(o => {
      if(o.value != this.allOption && !o.selected) {
        result = false;
      }
    });

    return result;
  }

  getTooltipString() {
    let result = '';
    const options = this.allOption.Selected ? this.control?.value.slice(1) : this.control?.value;

    options.forEach((o, index) => {
      result += o.Description;

      if(index < options.length - 1) {
        result += ', ';
      }
    })
    return result;
  }

  getSelectCount() {
    return (this.control.value?.length <= this.options.length) 
      ? this.control.value?.length 
      : this.control.value?.length - 1;
  }

}
